/*
 * @Author: liyxt
 * @Date: 2019-10-14 11:19:57
 * @LastEditors: liyxt
 * @LastEditTime: 2020-06-02 10:36:21
 * @Description: file content
 */
/*
*   between 类型的number组件
* */
import React, { Component } from 'react';
import { isFunction, isArray } from '@platform/api';
import NCNumber from '../Number/refactor_index';
import { toast, getMultiLang } from '@platform/api';
import { getSysFieldid } from '@platform/api';

require('./index.less');

class BetweenNum extends Component {
    constructor(props) {
        super(props);
        let { defaultPlaceholder = {} } = props;
        this.state = {
            langJson: {},
            start: { placeholder: props.placeholder + defaultPlaceholder.start || '起始' },
            end: { placeholder: props.placeholder + defaultPlaceholder.end || '结束' },
            scale: props.scale || 0,
            disabled: props.disabled,
            min: props.min,
            max: props.max,
        };
        this.mergeData(props);
        //不知道为什么先注释掉 看不懂这个逻辑
        // if (props.hasOwnProperty('disabled')) {
        // 	this.state.scale = props.disabled;
        // }
    }
    UNSAFE_componentWillMount() {
        let callback = (langJson, bool) => {
            if (bool) {
                this.setState({ langJson });
            }
        };
        getMultiLang({ moduleId: 'base_betweenNumber', callback });
    }

    /* props 更新 */
    componentWillReceiveProps(props) {
        this.mergeData(props);
        this.setState(this.state);
    }

    /* 合并数据 */
    mergeData(props) {
        this.state.start = Object.assign(this.state.start, props.start);
        this.state.start.placeholder = props.defaultPlaceholder.start;
        this.state.end = Object.assign(this.state.end, props.end);
        this.state.end.placeholder = props.defaultPlaceholder.end;
        this.state.disabled = props.disabled;
        if (props.value && isArray(props.value)) {
            if (props.value[0] && props.value[1] && Number(props.value[0]) > Number(props.value[1])) {
                console.error('BetweenNum控件的起始值不能大于结束值');
                return false;
            }
            this.state.start.value = props.value[0] || '';
            this.state.end.value = props.value[1] || '';
        } else if (props.value && !isArray(props.value)) {
            console.error('BetweenNum控件的value值为数组类型');
            return false;
        }
    }

    /* 失去焦点事件 */
    inputBlur(pos, val) {
        if (pos === 'end' && val && this.state.start.value && Number(val) < Number(this.state.start.value)) {
            toast({ mark: 'between-number', color: 'danger', content: this.state.langJson['between-0001'] || '结束值不能小于起始值' });
            val = this.state.start.value;
        }
        if (pos === 'start' && val && this.state.end.value && Number(val) > Number(this.state.end.value)) {
            toast({ mark: 'between-number', color: 'danger', content: this.state.langJson['between-0002'] || '起始值不能大于结束值' });
            val = this.state.end.value;
        }
        this.state[pos].value = val;
        this.setState(this.state);
        if (isFunction(this.props.onBlur)) {
            let res = [this.state.start.value, this.state.end.value];
            this.props.onBlur(res);
        }
    }

    /* change事件 */
    changeNumber(pos, val) {
        this.state[pos].value = val;
        this.setState(this.state);
        if (isFunction(this.props.onChange)) {
            let res = [this.state.start.value, this.state.end.value];
            this.props.onChange(res);
        }
    }

    render() {
        let { fieldid, mustFill, ...others } = this.props;
        fieldid = getSysFieldid(fieldid);
        return (
            <div className="NC_BetweenNum" fieldid={fieldid || null}>
                <div className="startNum">
                    <NCNumber
                        {...others}
                        onBlur={this.inputBlur.bind(this, 'start')}
                        scale={this.state.scale}
                        value={this.state.start.value === null ? '' : this.state.start.value}
                        placeholder={this.state.start.placeholder}
                        onChange={this.changeNumber.bind(this, 'start')}
                        disabled={this.state.disabled}
                        max={this.state.max}
                        min={this.state.min}
                    />
                </div>
                <span className="betweenLine">-</span>
                {mustFill}
                <div className="endNum">
                    <NCNumber
                        {...others}
                        onBlur={this.inputBlur.bind(this, 'end')}
                        scale={this.state.scale}
                        value={this.state.end.value === null ? '' : this.state.end.value}
                        placeholder={this.state.end.placeholder}
                        onChange={this.changeNumber.bind(this, 'end')}
                        disabled={this.state.disabled}
                        max={this.state.max}
                        min={this.state.min}
                    />
                </div>
            </div>
        );
    }
}

export default BetweenNum;
